import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserPermission } from '../enums/user-permission.enum';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[appEnableForRoles]',
    standalone: false,
})
export class EnableForRolesDirective implements OnInit {
    private requiredRoles: Array<UserPermission> = [];

    constructor(private authService: AuthService, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

    @Input() set appEnableForRoles(roles: Array<UserPermission>) {
        this.requiredRoles = roles;
    }

    public ngOnInit(): void {
        this.viewContainer.clear();
        this.authService.hasAtLeastOneRole$(this.requiredRoles).subscribe((isAllowed: boolean) => {
            if (isAllowed) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
